import { useParams } from "react-router-dom";
import useAxios from "../../../hooks/useAxios";
import { useEffect, useState } from "react";
import SystemInfo from "../../../util/SystemInfo";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

const PowerBiDetail = () => {

    const { id } = useParams();

    const [title, setTitle] = useState("");

    const [{ data: data, loading: loading }, getPowerBi] = useAxios({ url: `/power-bi/${id}/detail` }, { useCache: false });

    const [{ }, storePowerBiView] = useAxios({ url: `/power-bi-views`, data: { powerbiId: id }, method: 'POST' }, { useCache: false });

    useEffect(() => {
        if (data) {
            setTitle(document.querySelector('title').textContent);
            document.querySelector('title').textContent = `${data?.data?.title} | ${SystemInfo?.name}`;
        } else {
            if (title) {
                document.querySelector('title').textContent = title;
            } else {
                document.querySelector('title').textContent = SystemInfo?.name;
            }
        }
    }, [data]);

    const reportData = data?.data;
    const isEmbedded = reportData?.isEmbedded && reportData?.embedToken && reportData?.embedUrl;

    const formatPublicUrl = (url) => {
        if (!url) return '';
        let formatted = url;
        if (formatted.includes('filterPaneEnabled=')) {
            formatted = formatted.replace(/filterPaneEnabled=(true|false)/gi, 'filterPaneEnabled=false');
        } else {
            const separator = formatted.includes('?') ? '&' : '?';
            formatted = `${formatted}${separator}filterPaneEnabled=false`;
        }
        if (formatted.includes('navContentPaneEnabled=')) {
            formatted = formatted.replace(/navContentPaneEnabled=(true|false)/gi, 'navContentPaneEnabled=false');
        } else {
            const separator = formatted.includes('?') ? '&' : '?';
            formatted = `${formatted}${separator}navContentPaneEnabled=false`;
        }
        return formatted;
    };

    return (
        <div>
            <h2 className="mb-4 text-primary">
                {reportData?.title}
            </h2>

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner">
                        <div className="double-bounce1 bg-primary"></div>
                        <div className="double-bounce2 bg-primary"></div>
                    </div>
                    <p className="mt-3 text-muted">Cargando Power BI seguro...</p>
                </div>
            ) : isEmbedded ? (
                <div style={{ height: '85vh', width: '100%' }}>
                    <PowerBIEmbed
                        embedConfig={{
                            type: 'report',
                            id: reportData.reportId,
                            embedUrl: reportData.embedUrl,
                            accessToken: reportData.embedToken,
                            tokenType: models.TokenType.Embed,
                            settings: {
                                panes: {
                                    filters: { expanded: false, visible: false },
                                    pageNavigation: { visible: false }
                                },
                                navContentPaneEnabled: false,
                                background: models.BackgroundType.Default,
                            }
                        }}
                        cssClassName={"w-100 h-100"}
                    />
                </div>
            ) : reportData?.url ? (
                <iframe style={{ width: '100%', minHeight: '100vh', border: 0 }} src={formatPublicUrl(reportData?.url)} title={reportData?.title || "Power BI"} />
            ) : (
                <div className="alert alert-warning text-center">
                    No se encontró una configuración válida ni URL pública para este reporte de Power BI.
                </div>
            )}
        </div>
    );
}

export default PowerBiDetail;